import { TDashboardSegment } from '@api/lendingAPI/dashboardSegmentResponse.types';

import { ApplyDashboard } from './ApplyDashboard';
import { BusinessSupportDashboard } from './BusinessSupportDashboard';
import { OfferReadyDashboard } from './OfferReadyDashboard';
import { ShareBankStatementsDashboard } from './ShareBankStatementsDashboard';
import { TAccountFeatureMap } from '../../multiLoanDashboard/AccountFeatureEvaluator/AccountFeatureEvaluator';

type TSegmentLayout = React.ComponentType<{
    accountId: string;
    features: TAccountFeatureMap;
}>;

export const LAYOUTS: Partial<Record<TDashboardSegment, TSegmentLayout>> = {
    business_support: BusinessSupportDashboard,
    offer_ready: OfferReadyDashboard,
    share_bs: ShareBankStatementsDashboard,
    apply: ApplyDashboard
};

export const hasSegmentLayout = (segment: TDashboardSegment): boolean =>
    Boolean(LAYOUTS[segment]);
